// extracted by mini-css-extract-plugin
export var divider = "_dz-7";
export var itemsToggle = "_dz-8";
export var mergeModal = "_dz-1";
export var optionCard = "_dz-4";
export var radioGroup = "_dz-6";
export var radioOption = "_dz-0";
export var selected = "_dz-5";
export var shipmentOptions = "_dz-2";
export var tableOptions = "_dz-3";